import { buildNum } from "../utils/format";

export default {
    price: buildNum(10, 'K'),
    hasCustomNavbar: true,
    hasCustomBackground: true,
    light: {
        primary: '#E89820',
        secondary: '#A0A0A0',
        accent: '#D18147',
    },
    dark: {
        primary: '#E89820',
        secondary: '#A0A0A0',
        accent: '#D18147',
    }
}
